import { Anchor, Icon, SubjectNewsSVG } from "@newsela/angelou";

import ContentCard from "@/components/ContentCard/";
import HorizontalScrollContainer from "@/components/HorizontalScrollContainer";
import useGetUserExperimentSegment from "@/features/useGetUserExperimentSegment";

import AILunaTag from "@/components/AIComponents/AILunaTag/AILunaTag";

import { CardViewmodelAndProps } from "@/components/ContentCard/ContentCard.interface";
import { ContentRowProps } from "../ContentRow.interface";

import {
  contentScrollableListCss,
  defaultHeadingCss,
  headerAndDescriptionContainerCss,
  headerDescriptionCss,
  headerIconCss,
  homepageDefaultRowContainerCss,
  linkCss,
  listItemCss,
  lunaContainerCss,
} from "./HomepageDefaultRow.styles";

// Removes reading skills from cards for experiment.
export const omitSkillsFromResults = (results: CardViewmodelAndProps[]) => {
  const newResults = [...results];
  newResults.forEach((card) => {
    if (card.metadata.content_type === "ARTICLE") {
      delete card.metadata.reading_skills;
    }
  });
  return newResults;
};

const HomepageDefaultRow = ({
  children,
  dataQaSelector = "",
  description,
  iconSvg,
  isLuna = false,
  title,
  url,
}: ContentRowProps) => {
  const [removeReadingSkillChips] = useGetUserExperimentSegment(
    "remove_reading_skills_from_cards",
  );

  const isExperimentRemoveReadingSkillChipsFromSearch =
    removeReadingSkillChips === "on";

  if (children.length === 0) {
    return null;
  }

  const contentItems = children.slice(0, 8);

  const sanitizedResults = isExperimentRemoveReadingSkillChipsFromSearch
    ? omitSkillsFromResults(contentItems)
    : contentItems;

  return (
    <section css={homepageDefaultRowContainerCss}>
      <div css={headerAndDescriptionContainerCss}>
        <div css={defaultHeadingCss}>
          <Icon
            SvgComponent={iconSvg || SubjectNewsSVG}
            __cssFor={{ root: headerIconCss }}
          />
          <span>{title}</span>
          {url ? (
            <Anchor href={url} __cssFor={linkCss}>
              View all
            </Anchor>
          ) : null}
          {isLuna ? (
            <div css={lunaContainerCss}>
              <AILunaTag />
            </div>
          ) : null}
        </div>

        <div css={headerDescriptionCss}>{description}</div>
      </div>
      <HorizontalScrollContainer>
        <ul css={contentScrollableListCss}>
          {sanitizedResults.map((content, index) => (
            <li css={listItemCss} key={index}>
              <ContentCard {...content} dataQaSelector={dataQaSelector} />
            </li>
          ))}
        </ul>
      </HorizontalScrollContainer>
    </section>
  );
};

export default HomepageDefaultRow;
